<template>
  <div>
	<div>
		<h2>Timesheets</h2>
    <div v-for="l in list" v-bind:key="l.TimesheetID">
      <p>{{l.TimesheetID}}  {{l.Status}}</p><br></br>
    </div>
	</div>
  </div>
</template>

<script>

import envConfig from './env_config.js'
import axios from 'axios'
const http = axios.create({
  withCredentials: false,
  crossdomain: true
})
export default {
  name: 'Timesheets',
  props: {
  },
  data () {
    return {
      list:[]
    }
  },
  methods: {
    loadTimeSheets:function(){

      this.pageloading = true;
      var self = this;

      
      http.post(envConfig.API, JSON.stringify({ a: 'TimesheetsGet', JWT: localStorage.getItem('JWT') })).then(ret => {
        debugger;
        self.list = ret.data.list
        
      }).catch(function () {
        debugger;
      })
    }
  },
  mounted() {
    this.loadTimeSheets();
  },
  created: function () {

  },
        
  beforeCreate: function() {
      document.body.className = this.$route.fullPath.substr(1);
  }
}

</script>
<style>
</style>





